import { render } from "./CompletedDeviations.vue?vue&type=template&id=56919f1c"
import script from "./CompletedDeviations.vue?vue&type=script&lang=js"
export * from "./CompletedDeviations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__